import{gql as n}from"@apollo/client";const e=n`
  mutation addSummaryFeedbackRankAndNoteMatch(
    $contentSnippetSummaryId: Int!
    $note: String
    $questionAnswerId: Int!
    $questionResponseId: Int!
    $rank: Int
  ) {
    summaryFeedback {
      addSummaryFeedbackRankAndNoteMatch: addFeedbackRankAndNoteMatch(
        contentSnippetSummaryId: $contentSnippetSummaryId
        matchResponseId: $questionResponseId
        note: $note
        questionAnswerId: $questionAnswerId
        sort: $rank
      )
    }
  }
`;export{e as ADD_SUMMARY_FEEDBACK_RANK_AND_NOTE_MATCH_MUTATION};
//# sourceMappingURL=SummaryFeedbackConfigurationRankAndNotes.graphql.js.map
